import uuid1 from "uuid/v1";

import { getQueryVariable } from "utils";
import { removeLocalStorage } from "utils/storage";
import { restartWebsocket } from "actions/config";

export default ({ data, functions }) => {
  const origin = getQueryVariable("origin", document.location.search);
  const botId = getQueryVariable("botId", document.location.search);
  const { cvars, mod_id: moduleId, reset, webchatKey } = data;
  const { dispatch } = functions;

  const dataToWebsocket = {
    id: botId,
    cvars,
    origin,
    referral: moduleId,
    user_id: `webbot:${uuid1()}`,
    webchatKey,
  };

  if (reset) {
    removeLocalStorage(botId, webchatKey);
  }

  dispatch(restartWebsocket({ dataToWebsocket, dataToResetConversation: {} }));
};
